import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _badge = { functionUpdateDate: 'google.protobuf.Timestamp' };
var _badgeList = { badges: '_badge' };
var _category = { createdDate: 'google.protobuf.Timestamp' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _dateAndTimeSettings = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    recurringEvents: '_recurrences',
};
var _design = { poll: '_pollDesign' };
var _event = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    publishedDate: 'google.protobuf.Timestamp',
    location: '_location',
    dateAndTimeSettings: '_dateAndTimeSettings',
    mainImage: '_commonImage',
    registration: '_registration',
    categories: '_eventCategories',
    description: '_richContent',
    badges: '_badgeList',
};
var _eventCategories = { categories: '_eventCategory' };
var _eventCategory = { createdDate: 'google.protobuf.Timestamp' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getWidgetDataRequest = {};
var _getWidgetDataResponse = {
    events: '_event',
    singleDemoEvents: '_event',
    listDemoEvents: '_event',
    categories: '_category',
};
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _location = { address: '_address' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _occurrence = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _recurrences = { individualEventDates: '_occurrence' };
var _registration = { rsvp: '_rsvpRegistration' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _rsvpRegistration = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveComWixpressEventsUiV1WidgetDataServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-ui-serverless',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getWidgetData(payload) {
    var _a = serializer(_getWidgetDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWidgetDataResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badge: _badge,
        _badgeList: _badgeList,
        _category: _category,
        _commonImage: _commonImage,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getWidgetData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.ui.v1.widget_data',
            method: 'GET',
            methodFqn: 'com.wixpress.events.ui.v1.WidgetDataService.GetWidgetData',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressEventsUiV1WidgetDataServiceUrl({
                protoPath: '/v1/widget-data',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWidgetData.fromReq = fromReq;
    __getWidgetData.__isAmbassador = true;
    return __getWidgetData;
}
//# sourceMappingURL=http.impl.js.map